import { ENDPOINT, STATUS } from "../../constants/server/api";
import { fetchApiData } from "../../utils/apiUtils";

export const getUserAdminById = (adminId) => async (dispatch) => {
  console.log("adminId : ", adminId);

  const res = await fetchApiData({
    method: "get",
    endpoint: `${ENDPOINT.SA_USER_ADMIN}/${adminId}`,
    dispatch,
  });

  if (res) {
    return res;
  }
  return null;
};

export const getUserAdmins = (params) => async (dispatch) => {
  const data = await fetchApiData({
    method: "get",
    endpoint: `${ENDPOINT.SA_USER_ADMIN}/pagination`,
    params: {
      page: params?.page,
      perPage: params?.perPage,
      s: params?.s,
      sortBy: params?.sortBy,
      sortOrder: params?.sortOrder,
    },
    dispatch,
  });

  if (data) {
    return data;
  }
  return null;
};

export const updateUserAdminEmail = (userId, email) => async (dispatch) => {
  const data = await fetchApiData({
    method: "put",
    endpoint: `${ENDPOINT.SA_USER_ADMIN}/${userId}/email`,
    data: { email },
    dispatch,
  });

  if (data) {
    return data;
  }
  return null;
};

export const updateUserAdminPassword =
  (userId, password) => async (dispatch) => {
    const data = await fetchApiData({
      method: "put",
      endpoint: `${ENDPOINT.SA_USER_ADMIN}/${userId}/password`,
      data: { password },
      dispatch,
    });

    if (data) {
      return data;
    }
    return null;
  };

export const updateUserAdmin = (userId, formValues) => async (dispatch) => {
  const formData = new FormData();

  if (formValues.prefix_name_id)
    formData.append("prefix_name_id", Number(formValues.prefix_name_id));
  if (formValues.gender_id)
    formData.append("gender_id", Number(formValues.gender_id));
  if (formValues.first_name)
    formData.append("first_name", formValues.first_name);
  if (formValues.last_name) formData.append("last_name", formValues.last_name);
  if (formValues.nickname) formData.append("nickname", formValues.nickname);
  if (formValues.birth_date) {
    formData.append("birth_date", formValues.birth_date);
  }
  formData.append(
    "phone_number",
    formValues.phone_number ? String(formValues.phone_number) : null
  );

  if (formValues.image_path) {
    if (formValues.image_path instanceof File) {
      formData.append("image_path", formValues.image_path);
    } else if (
      typeof formValues.image_path === "string" &&
      formValues.image_path.startsWith("data:image")
    ) {
      const blob = await fetch(formValues.image_path).then((r) => r.blob());
      formData.append("image_path", blob, "image.jpg");
    }
  }

  const data = await fetchApiData({
    method: "put",
    endpoint: `${ENDPOINT.SA_USER_ADMIN}/${userId}`,
    data: formData,
    dispatch,
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });

  if (data) {
    return data;
  }
  return STATUS.OK;
};

export const exportUserAdminToExcel = (searchTerm) => async (dispatch) => {
  const data = await fetchApiData({
    method: "post",
    endpoint: `${ENDPOINT.SA_USER_ADMIN}/excel`,
    params: {
      s: searchTerm || "",
    },
    responseType: "blob",
    dispatch,
  });

  if (data) {
    const url = window.URL.createObjectURL(new Blob([data]));
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", "รายการผู้ดูแลระบบ.xlsx");
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(url);
  }
  return null;
};

export const createUserAdmin = (formValues) => async (dispatch) => {
  const formData = new FormData();

  formData.append("prefix_name_id", Number(formValues.prefix_name_id));
  formData.append("gender_id", Number(formValues.gender_id));
  formData.append("first_name", formValues.first_name);
  formData.append("last_name", formValues.last_name);
  formData.append("nickname", formValues.nickname);
  formData.append("phone_number", formValues.phone_number);
  formData.append("email", formValues.email);
  formData.append("password", formValues.password);
  if (formValues.image_path) {
    if (formValues.image_path instanceof File) {
      formData.append("image_path", formValues.image_path);
    } else if (
      typeof formValues.image_path === "string" &&
      formValues.image_path.startsWith("data:image")
    ) {
      const blob = await fetch(formValues.image_path).then((r) => r.blob());
      formData.append("image_path", blob, "image.jpg");
    }
  }

  const data = await fetchApiData({
    method: "post",
    endpoint: ENDPOINT.SA_USER_ADMIN,
    data: formData,
    dispatch,
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });

  if (data) {
    return data;
  }
  return null;
};
